import * as XLSX from 'xlsx';

const DownloadPurchaseBillExcel = (billList, companyName, setOpenBackdrop) => {
    if (!billList || billList.length === 0) {
        alert("No data found to export!");
        return;
    }

    setOpenBackdrop(true);

    try {
        const rows = [];
        rows.push([companyName.toUpperCase()]);
        rows.push(["PURCHASE BILL SUMMARY REPORT"]);
        rows.push([]);

        // Table Headers with New Fields
        const headers = [
            "Bill No", "Order No", "Billing Date", "Due Date", "Supplier", 
            "Challans", "Item Name", "Qty", "Unit", "Rate", "Amount", "Bill Total"
        ];
        rows.push(headers);

        billList.forEach((bill) => {
            const challanString = bill.challans?.map(c => c.challan_no).join(", ") || "";
            
            bill.items.forEach((item, index) => {
                rows.push([
                    index === 0 ? bill.purchase_bill_no : "",
                    index === 0 ? (bill.purchase_order_no || "N/A") : "",
                    index === 0 ? bill.billing_date : "",
                    index === 0 ? bill.bill_due_date : "",
                    index === 0 ? bill.suppliers?.contact_name : "",
                    index === 0 ? challanString : "",
                    item.product?.item_name,
                    Number(item.quantity),
                    item.product?.unit,
                    Number(item.rate),
                    Number(item.total_amount),
                    index === 0 ? Number(bill.total_amount) : ""
                ]);
            });
            rows.push([]); 
        });

        const worksheet = XLSX.utils.aoa_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Purchase Bills");

        // Set column widths
        worksheet['!cols'] = [
            { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 20 }, 
            { wch: 20 }, { wch: 25 }, { wch: 8 }, { wch: 8 }, 
            { wch: 10 }, { wch: 12 }, { wch: 15 }
        ];

        XLSX.writeFile(workbook, `Purchase_Bills_${new Date().getTime()}.xlsx`);
    } catch (error) {
        console.error("Excel Error:", error);
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadPurchaseBillExcel;